export default {
  setSSeInfo({commit, state}, {prop, val}) {
    commit('SET_SSeInfo', {prop, val})
  },
  delSSeInfo({commit, state}) {
    commit('DEL_SSeInfo')
  },
  setWarehouseFloor({commit, state}, val) {
    commit('setWarehouseFloor', val)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js